import { errorsActions } from '../../store/errors';

export default async function onCacheEntryAdded(_, { dispatch, cacheDataLoaded, getCacheEntry }) {
  await cacheDataLoaded;
  const res = getCacheEntry().data;
  dispatch(errorsActions.push({ status: 200, data: res.message }));
}
